import { Button, message } from 'antd'
import { MainApi } from '../api/Main'
import useSubmit from '../elements/Hooks/useSubmit'
import React from 'react'

function DuplicateLineButton({ selection, disabled, fetch, setSelection }) {
  const [duplicating, duplicateFunc] = useSubmit(MainApi.duplicate, true)

  async function duplicateSelection() {
    await duplicateFunc({ selection })
    setSelection([])
    fetch()
  }

  return (
    <>
      <Button
        size={'small'}
        type={'danger'}
        loading={duplicating}
        onClick={duplicateSelection}
        disabled={disabled}
        style={{ marginLeft: '10px' }}>
        Duplicate
      </Button>
    </>
  )
}

export default DuplicateLineButton
